import { isValidPhoneNumber } from 'libphonenumber-js';

const MIN_NAME_LEN = 2;

export const isValidEmail = (email: string) => {
    return email.trim() == ''
        ? false
        : /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(email);
};

export const isValidName = (value: string) => {
    const name = value.trim();

    return name === '' || name.length < MIN_NAME_LEN
        ? false
        : /^[a-zA-Z']+([a-zA-Z-' ]+[a-zA-Z'])?$/.test(value);
};

export const isValidPhone = (phone: string) => {
    return isValidPhoneNumber(phone);
};
